import React, { useState, useEffect } from 'react';
import './Navbar.css';
import logo from '../assets/veltroz-logobg.png';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        {/* ✅ Replaced text with image logo */}
        <div className="navbar-logo" onClick={() => scrollToSection('hero')}>
          <img src={logo} alt="Veltroz Logo" className="logo-image" />
        </div>

        <div className={`navbar-menu ${isMobileMenuOpen ? 'active' : ''}`}>
          <a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}>About Us</a>
          <a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>Our Services</a>
          <a href="#internship" onClick={(e) => { e.preventDefault(); scrollToSection('internship'); }}>Internship</a>
          <a href="#founders" onClick={(e) => { e.preventDefault(); scrollToSection('founders'); }}>Our Founders</a>
          <a href="#cofounders" onClick={(e) => { e.preventDefault(); scrollToSection('cofounders'); }}>Our Co-Founders</a>
          <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>Contact Us</a>
        </div>

        <div className="navbar-toggle" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
